import { API_CONFIG, ApiConfig } from '@prenuvo/paw-print-shared';

type Config = {
  BASE_URL: ApiConfig;
};

export const CONFIG: Config = {
  BASE_URL: API_CONFIG,
} as const;
